export default __webpack_public_path__ + "static/media/browser.4d3edd46.png";